


const initialState = {
    data :{},
    loading:false,
    error : null
}

export default function userReducer (state = initialState, action) {
    switch(action.type){
        default: return state
    }
}

